import { Link } from "react-router-dom";
import { Sparkles, Lock } from "lucide-react";
import { useBilling } from "@/context/BillingContext";

const fmt = (ts) => new Date(ts * 1000).toLocaleDateString(undefined, { day: "numeric", month: "short" });

function Bar({ tone, icon: Icon, children, cta, testId = "trial-banner" }) {
  const bg = { lock: "bg-rose-500/10 border-rose-400/20", warn: "bg-[var(--accent)]/10 border-[var(--accent)]/25", calm: "bg-white/[0.02] border-white/[0.06]" }[tone];
  return (
    <div data-testid={testId} className={`flex flex-wrap items-center gap-x-4 gap-y-2 px-5 sm:px-10 lg:px-14 py-3 border-b text-sm ${bg}`}>
      <Icon size={15} className={tone === "lock" ? "text-rose-300" : "text-[var(--accent)]"} />
      <span className="text-[var(--ink)]" data-testid="trial-banner-text">{children}</span>
      <Link to="/billing" data-testid="trial-banner-subscribe" className="ml-auto btn-accent text-xs !py-1.5">{cta}</Link>
    </div>
  );
}

export default function TrialBanner() {
  const { billing } = useBilling();
  if (!billing || billing.exempt) return null;
  const extra = billing.extra_tasks || 0;

  if (billing.subscribed) {
    const p = billing.period;
    const left = (p?.left || 0) + extra;
    if (!p || left > 50) return null;
    if (left === 0) return <Bar tone="lock" icon={Lock} cta="Refill 800 · ₹85">You've used this month's 800 tasks — resets {fmt(p.resets_at)}.</Bar>;
    return <Bar tone="warn" icon={Sparkles} cta="Refill 800 · ₹85"><b data-testid="trial-free-left">{left}</b> tasks left this month{extra ? ` (incl. ${extra} bonus)` : ""} · resets {fmt(p.resets_at)}</Bar>;
  }

  const left = billing.free_left + extra;
  const total = billing.tasks_used + left;
  if (left === 0) return <Bar tone="lock" icon={Lock} cta="Subscribe · ₹85/month">Your free tasks are used — dictation is paused. Your history is still here.</Bar>;
  return (
    <Bar tone={left <= 2 ? "warn" : "calm"} icon={Sparkles} cta="Go Pro · ₹85/month">
      <b data-testid="trial-free-left">{left}</b> free tasks left{extra ? ` (incl. ${extra} bonus)` : ""}{left <= 2 ? " — almost out!" : ""}
      <span className="ml-3 inline-flex gap-1 align-middle" aria-hidden>
        {Array.from({ length: Math.min(total, 15) }).map((_, i) => (
          <span key={i} className={`inline-block w-4 h-1.5 rounded-full ${i < total - left ? "bg-white/15" : "bg-[var(--accent)]"}`} />
        ))}
      </span>
      <Link to="/invite" data-testid="trial-banner-invite" className="ml-3 underline underline-offset-2 text-white/60 hover:text-white">Invite friends for +5</Link>
    </Bar>
  );
}
